/**
 * Initialize Navigation Dropdowns
 * Adds hover functionality for desktop, keeps click for mobile
 */
import { Dropdown } from 'bootstrap';

export default function initNavDropdown() {
    // Only apply hover behavior on desktop
    const isDesktop = () => window.innerWidth >= 1200; // xl breakpoint

    // Get all dropdown toggles in the main navbar (not offcanvas)
    const desktopNav = document.querySelector('#navbarNavDropdown');

    if (desktopNav) {
        const dropdownToggles = desktopNav.querySelectorAll('.dropdown-toggle');

        dropdownToggles.forEach((toggle) => {
            const dropdownMenu = toggle.nextElementSibling;
            const dropdown = Dropdown.getOrCreateInstance(toggle);
            const parentLi = toggle.closest('.nav-item');

            if (!parentLi || !dropdownMenu) {
                return;
            }

            // Hover to show on desktop
            parentLi.addEventListener('mouseenter', function() {
                if (isDesktop()) {
                    dropdown.show();
                }
            });

            // Hover to hide on desktop
            parentLi.addEventListener('mouseleave', function() {
                if (isDesktop()) {
                    dropdown.hide();
                }
            });

            // Prevent default click behavior on desktop (allow navigation to link)
            toggle.addEventListener('click', function(e) {
                if (isDesktop()) {
                    // If the dropdown toggle has a href and it's not just "#", navigate to it
                    const href = toggle.getAttribute('href');
                    if (href && href !== '#' && href !== '') {
                        window.location.href = href;
                        return;
                    }
                    // Otherwise prevent default to avoid Bootstrap's click toggle
                    e.preventDefault();
                }
                // On mobile, let Bootstrap handle the click normally
            });
        });
    }

    // Initialize dropdowns in offcanvas menu
    const offcanvasNav = document.querySelector('#offcanvasNavbar');

    if (offcanvasNav) {
        const offcanvasDropdownToggles = offcanvasNav.querySelectorAll('.dropdown-toggle');

        offcanvasDropdownToggles.forEach((toggle) => {
            const dropdown = Dropdown.getOrCreateInstance(toggle);

            // Ensure click toggles work in offcanvas
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                dropdown.toggle();
            });
        });
    }
}
